const aboutUs={
    NAME:"علی محمد یاوری",
    JOB:"مدرس و طراح برنامه های کاربردی تحت اکسل",
    RESUME_L1:"من، علی محمد یاوری، متولد یزد فارغ‌التحصیل ارشد عمران- راه و ترابری از دانشگاه علم و صنعت از سال ۱۳۹۱ بنا به نیازم و بعدا علاقه‌مندیم به این نرم‌افزار جذاب، اکسل رو شروع کردم و تا حالا فایل‌های زیادی رو برای شرکت‌ها و اشخاص تحت اکسل تهیه کرده و برنامه‌های زیادی رو با VBA تحت اکسل نوشتم.",
    RESUME_L2:"توی این اپلیکیشن قراره دانش خودم از قسمت‌ها و موارد کاربردی اکسل و سایر برنامه‌های مجموعه آفیس را در اختیارتون بزارم.",
    PROBLEM:"در صورت مشکل در پرداخت با شماره های زیر در ارتباط باشید (پیام در واتس اپ یا تلگرام)"
}
export default aboutUs